import { render, staticRenderFns } from "./miPerfilBarragan.vue?vue&type=template&id=3b84b392&scoped=true&"
import script from "./miPerfilBarragan.vue?vue&type=script&lang=js&"
export * from "./miPerfilBarragan.vue?vue&type=script&lang=js&"
import style0 from "./miPerfilBarragan.vue?vue&type=style&index=0&id=3b84b392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84b392",
  null
  
)

export default component.exports